import React, { useEffect, useState, useRef } from "react";
import './Botoesmobile.css';
import { useMediaQuery } from 'react-responsive';
import { sendCommandFlex35 } from "../../../API/AcionamentoFlex35";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../../API/FeedBackLuzes";

function BotoesMobile() {
  
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Ajuste o valor conforme necessário

  const groupRefs = useRef({
    grupo08: React.createRef(),
    grupo09: React.createRef(),
    grupo10: React.createRef(),
    grupo11: React.createRef(),
    grupo12: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo08: false,
    grupo09: false,
    grupo10: false,
    grupo11: false,
    grupo12: false,

  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes:", statusDasLuzesFlex35);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8300);
  
    return () => clearInterval(intervalId);
  }, []);


  const updateLightGroup = () => {
    setImageStates({
      grupo08: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo09: statusDasLuzesFlex35.includes("1I10") && !statusDasLuzesFlex35.includes("1I00"),
      grupo10: statusDasLuzesFlex35.includes("1J10") && !statusDasLuzesFlex35.includes("1J00"),
      grupo11: statusDasLuzesFlex35.includes("1K10") && !statusDasLuzesFlex35.includes("1K00"),
      grupo12: statusDasLuzesFlex35.includes("1L10") && !statusDasLuzesFlex35.includes("1L00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };
  
  if (!isMobile) {
    return null; // Não renderiza o componente em telas maiores
  }

  if (loading) {
    return null;
  }

  return (

    <div id="BotoesMobile">
        <h2 id='Title-botoes-Mobile'>Intermediário</h2>
        {/* Botões para clicar em cima da legenda */}
        <div className="campoBotoesAcionamento-mobile">
          <div
            ref={groupRefs.current.grupo08}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '76.4%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo08', !imageStates.grupo08);
              sendCommandFlex35('Hall Entrada', imageStates.grupo08 ? '1H00' : '1H10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo08 ? 'Highlighted' : ''}`}>8</p>
            <p className="textBar">Hall Entrada</p>
          </div>
          <div
            ref={groupRefs.current.grupo09}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '80.5%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo09', !imageStates.grupo09);
              sendCommandFlex35('Circulação', imageStates.grupo09 ? '1I00' : '1I10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo09 ? 'Highlighted' : ''}`}>9</p>
            <p className="textBar">Circulação</p>
          </div>
          <div
            ref={groupRefs.current.grupo10}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '84.6%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo10', !imageStates.grupo10);
              sendCommandFlex35('Varanda Teen Louge', imageStates.grupo10 ? '1J00' : '1J10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo10 ? 'Highlighted' : ''}`}>10</p>
            <p className="textBar">Varanda Teen Louge</p>
          </div>
          <div
            ref={groupRefs.current.grupo11}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '88.7%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo11', !imageStates.grupo11);
              sendCommandFlex35('Varanda Sport Bar', imageStates.grupo11 ? '1K00' : '1K10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo11 ? 'Highlighted' : ''}`}>11</p>
            <p className="textBar">Varanda Sport Bar</p>
          </div>
          <div
            ref={groupRefs.current.grupo12}
            className="campoGroup-clickable-element-mobile"
            style={{ top: '92.8%', left: '80%' }}
            onClick={() => {
              handleToggleLightGroup('grupo12', !imageStates.grupo12);
              sendCommandFlex35('Tomadas Sport Bar', imageStates.grupo12 ? '1L00' : '1L10');
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo12 ? 'Highlighted' : ''}`}>12</p>
            <p className="textBar">Tomadas Sport Bar</p>
          </div>             
        </div>
    </div>
  );
}

export default BotoesMobile;